module.exports = __webpack_public_path__ + "static/media/safe-pharmacy.93174fcb.png";